@if (screenReady$ | async) {
  <app-screen-shell
    [contentClass]="'container chat-add-members-screen'"
    titleKey="chat.addMembers"
    (back)="goBack()">

    <section class="chat-add-members-panel add-players-detail-screen">
      <div class="chat-add-member-tabs">
        <button type="button" [class.is-active]="addMemberSource === 'footballerFriends'" (click)="setAddMemberSource('footballerFriends')">
          {{ 'events.inviteFootballerFriendsTitle' | translate }}
        </button>
        <button type="button" [class.is-active]="addMemberSource === 'openProfiles'" (click)="setAddMemberSource('openProfiles')">
          {{ 'events.inviteOpenProfilesTitle' | translate }}
        </button>
      </div>

      <div class="invite-player-search">
        <div class="invite-player-search-box">
          <i [class]="'common.search' | nogoshIcon" aria-hidden="true"></i>
          <input [(ngModel)]="addMemberSearchText"
            [placeholder]="(addMemberSource === 'openProfiles' ? 'events.inviteOpenProfilesPlaceholder' : 'events.searchPlayers') | translate"
            name="addMemberSearchText"
            autocomplete="off"
            (keyup.enter)="searchAddMembers()">
          @if (addMemberSearchText) {
            <button type="button" class="invite-player-search-clear" [attr.aria-label]="'common.clear' | translate" (click)="clearAddMemberSearch()">
              <i [class]="'common.close' | nogoshIcon" aria-hidden="true"></i>
            </button>
          }
        </div>
        <button type="button" class="invite-player-search-action" [disabled]="addMemberLoading || (addMemberSource === 'openProfiles' && !addMemberSearchText.trim())" (click)="searchAddMembers()">
          @if (addMemberLoading) {
            <app-delayed-indicator></app-delayed-indicator>
          } @else {
            <i [class]="'common.search' | nogoshIcon" aria-hidden="true"></i>
          }
          <span>{{ 'events.invitePlayersSearch' | translate }}</span>
        </button>
      </div>

      @if (addMemberError) {
        <div class="alert alert-danger py-2 mb-3" role="alert">{{ addMemberError | translate }}</div>
      }

      @if (selectedAddMembers.length > 0) {
        <div class="invite-selected-summary mb-3">
          <div class="invite-selected-header">
            <div class="invite-selected-title">{{ 'events.invitePlayersSelectedCount' | translate:{count: selectedAddMembers.length} }}</div>
            <button type="button" class="btn btn-primary btn-sm px-3 chat-add-selected-button" [disabled]="addMemberSaving" (click)="addSelectedMembersToChat()">
              @if (addMemberSaving) {
                <app-delayed-indicator></app-delayed-indicator>
              }
              {{ 'common.add' | translate }}
            </button>
          </div>
          <div class="invite-selected-list">
            @for (player of selectedAddMembers; track player.id) {
              <button type="button" class="invite-selected-chip" (click)="removeSelectedAddMember(player)">
                <span>{{ player.nickName || player.name }}</span>
                <i [class]="'common.close' | nogoshIcon" aria-hidden="true"></i>
              </button>
            }
          </div>
        </div>
      }

      @if (addMemberNoResults && !addMemberLoading) {
        <div class="invite-player-empty">{{ 'events.invitePlayersNoResults' | translate }}</div>
      }

      @if (addMemberCandidates.length > 0) {
        <div class="invite-player-list">
          @for (player of addMemberCandidates; track player.id) {
            <button type="button" class="invite-player-row" [class.is-selected]="isSelectedAddMember(player)" (click)="toggleAddMemberCandidate(player)">
              <span class="invite-player-avatar">
                <img [src]="player.avatar ? player.avatar : '../../assets/images/user1.jpg'" onerror="this.src='../../assets/images/user1.jpg'" [alt]="'accessibility.userProfileImage' | translate">
              </span>
              <span class="invite-player-main">
                <span class="invite-player-name">{{ player.nickName || player.name }}</span>
                @if (player.name && player.nickName && player.name !== player.nickName) {
                  <span class="invite-player-meta">{{ player.name }}</span>
                }
              </span>
              <span class="invite-player-action">
                <i [class]="'common.plus' | nogoshIcon" aria-hidden="true"></i>
              </span>
            </button>
          }
        </div>
      }
    </section>
  </app-screen-shell>
}
